import axios from "axios";
import Config from "src/config";

const v2_actionPredictionAnalyzeChat = (agentId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/agentes/prediction/analyse-chat`,
        data
        });
};

export default v2_actionPredictionAnalyzeChat;
